import { render, staticRenderFns } from "./orgEdit.vue?vue&type=template&id=4a32be48"
import script from "./orgEdit.vue?vue&type=script&lang=js"
export * from "./orgEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports